import {css} from '@logistics-frontend/blocks/theme/css'

export const box = css`
  inline-size: 100%;
`
